import React from 'react';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

const CodeContainer = styled(motion.pre)(({ theme }) => ({
  margin: 0,
  fontFamily: '"JetBrains Mono", monospace',
  color: theme.palette.text.primary,
  lineHeight: 1.6,
  fontSize: '0.85rem',
  overflow: 'auto',
  '& .comment': {
    color: theme.palette.text.secondary,
  },
  '& .keyword': {
    color: '#ff79c6',
  },
  '& .function': {
    color: '#50fa7b',
  },
  '& .string': {
    color: '#f1fa8c',
  },
  '& .property': {
    color: theme.palette.secondary.main,
  },
  '& .number': {
    color: '#bd93f9',
  },
  '& .operator': {
    color: '#ff79c6',
  },
  '& .punctuation': {
    color: theme.palette.text.primary,
  }
}));

const AnimatedCode = ({ children, ...props }) => {
  const variants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.03,
      }
    }
  };

  const lineVariants = {
    hidden: { opacity: 0, y: 5 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
      }
    }
  };

  // Split by line breaks and wrap each line in a motion.div
  const animateLines = () => {
    if (typeof children === 'string') {
      return children.split('\n').map((line, i) => (
        <motion.div key={i} variants={lineVariants}>
          {line}
        </motion.div>
      ));
    }
    return children;
  };

  return (
    <CodeContainer
      variants={variants}
      initial="hidden"
      animate="visible"
      {...props}
    >
      {animateLines()}
    </CodeContainer>
  );
};

export default AnimatedCode;
